import React from 'react';
import { RepoConfigEditor } from './RepoConfigEditor';
import { Progress, EmptyState } from '@backstage/core-components';
import LockIcon from '@material-ui/icons/Lock';
import { useOpenFgaPermission } from '../../../../hooks/useOpenFgaPermission';

/**
 * RepoConfigEditor with permission check
 * Only users with 'can_manage_config' relation on the component can access this
 * Note: The tab visibility is controlled by TabPermissionGuard in the overview
 */
export const ProtectedRepoConfigEditor: React.FC = () => {
  const { allowed, loading, error } = useOpenFgaPermission('can_manage_config');

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return (
      <EmptyState
        missing="info"
        title="Error al verificar permisos"
        description={`No se pudieron verificar tus permisos: ${error.message}`}
      />
    );
  }

  if (!allowed) {
    return (
      <EmptyState
        missing="data"
        title="Acceso Denegado"
        description="No tienes permisos para editar la configuración de este componente. Solo usuarios con rol JP o DevOps pueden acceder a esta función."
        action={<LockIcon style={{ fontSize: 64, color: '#999' }} />}
      />
    );
  }

  return <RepoConfigEditor />;
};
